(() => {
  const setup = (root = document) => {
    root.querySelectorAll('.scah-usage').forEach((usage) => {
      if (usage.dataset.ready) return;
      usage.dataset.ready = 'true';
      usage.querySelectorAll('[data-use-button]').forEach(button => button.addEventListener('click', () => {
        const key = button.dataset.useButton;
        usage.querySelectorAll('[data-use-button]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.useButton === key)));
        usage.querySelectorAll('[data-use-photo]').forEach(el => { el.hidden = el.dataset.usePhoto !== key; });
        usage.querySelectorAll('[data-use-panel]').forEach(el => { el.hidden = el.dataset.usePanel !== key; });
      }));
    });
    root.querySelectorAll('.sn-review-carousel').forEach((carousel) => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const reviews = [...carousel.querySelectorAll('[data-review]')];
      const dots = [...carousel.querySelectorAll('.sn-review-dots i')];
      let active = 0;
      const show = () => {
        reviews.forEach((review, index) => { review.hidden = index !== active; });
        dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
      };
      carousel.querySelector('[data-review-next]')?.addEventListener('click', () => { active = (active + 1) % reviews.length; show(); });
      carousel.querySelector('[data-review-prev]')?.addEventListener('click', () => { active = (active - 1 + reviews.length) % reviews.length; show(); });
      if (reviews.length) show();
    });
    root.querySelectorAll('.sn-mobile-menu>nav a').forEach((link) => link.addEventListener('click', () => { link.closest('.sn-mobile-menu').open = false; }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup());
  else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
